import { useTranslation } from '../presentation/common/useTranslation.js';
import { levelProgress } from '../utils/worldProgress';

import { Link } from 'react-router-dom';

export default function PlayerProgress({ profile, variant = 'default' }) {
  const { t, i18n } = useTranslation();
  if (!profile) return null;
  const currentLevel = profile.level ?? profile.Level ?? 1;
  const currentXP = profile.totalExperience ?? profile.TotalExperience ?? 0;
  const progress = levelProgress(currentLevel, currentXP);
  const xp = currentXP.toLocaleString(i18n.language);
  const upperXP = progress.upper.toLocaleString(i18n.language);
  const remainingXP = progress.remaining.toLocaleString(i18n.language);
  const xpValue = t('player_progress.xp_value', { xp });
  const nextLevel = t('player_progress.next_level_xp', { xp: remainingXP });
  const nextLevelShort = t('player_progress.next_level_xp_short', { xp: remainingXP });

  if (variant === 'nav') {
    return (
      <Link to="/level-statistics" aria-label={t('player_progress.open_statistics')} className="player-progress-nav flex items-center gap-3 sm:gap-4 w-full md:w-[260px] lg:w-[340px] max-w-full hover:opacity-80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-amber-300 rounded">
        <div className="flex flex-col gap-1.5">
        <span className="player-progress-nav-level font-serif text-xl md:text-2xl whitespace-nowrap text-inherit font-bold">{t('dashboard_v2.level_short')} {progress.current}</span>
        <div role="progressbar" aria-label={t('player_progress.level_progress')} aria-valuemin={0} aria-valuemax={100} aria-valuenow={Math.round(progress.percent)} title={`${xpValue} / ${t('player_progress.xp_value', { xp: upperXP })}`} className="player-progress-nav-track player-progress-nav-track-mobile md:hidden">
          <div className="player-progress-nav-fill player-progress-nav-fill-mobile" style={{ width: progress.percent + '%' }} />
        </div>
        </div>
        <div className="flex-1 hidden md:block">
          <div className="flex justify-between items-end mb-1.5 font-medium px-0.5 gap-4">
            <span className="player-progress-nav-xp text-sky-400 text-xs md:text-sm font-bold tracking-wide">{xpValue}</span>
            <span className="player-progress-nav-next text-violet-200/80 text-[10px] md:text-xs whitespace-nowrap">{progress.current < 100 ? nextLevelShort : t('player_progress.max_short')}</span>
          </div>
          <div role="progressbar" aria-label={t('player_progress.level_progress')} aria-valuemin={0} aria-valuemax={100} aria-valuenow={Math.round(progress.percent)} className="player-progress-nav-track h-2 md:h-2.5 rounded-full bg-slate-700 overflow-hidden shadow-inner border border-black/20">
            <div className="player-progress-nav-fill h-full rounded-full bg-sky-400 shadow-[inset_0_1px_1px_rgba(255,255,255,0.3)]" style={{ width: progress.percent + '%' }} />
          </div>
        </div>
      </Link>
    );
  }

  return (
      <Link to="/level-statistics" aria-label={t('player_progress.open_statistics')} className="player-progress-widget flex items-center gap-5 text-slate-200 hover:opacity-80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-amber-300 rounded">
      <span className="player-progress-level font-serif text-3xl whitespace-nowrap">{t('dashboard_v2.level_short')} {progress.current}</span>
      <div className="flex-1">
        <div className="flex flex-wrap justify-between gap-2 text-sm mb-2">
          <span className="player-progress-xp text-sky-300">{xpValue}</span>
          <span className="player-progress-next text-violet-200/80">{progress.current < 100 ? nextLevel : t('player_progress.max_level_reached')}</span>
        </div>
        <div role="progressbar" aria-label={t('player_progress.level_progress')} aria-valuemin={0} aria-valuemax={100} aria-valuenow={Math.round(progress.percent)} className="player-progress-bar-track h-2 rounded-full bg-slate-700 overflow-hidden">
          <div className="player-progress-bar-fill h-full rounded-full bg-sky-300" style={{ width: progress.percent + '%' }} />
        </div>
      </div>
    </Link>
  );
}
